import {
  collection,
  addDoc,
  getDocs,
  doc,
  updateDoc,
  deleteDoc,
  orderBy,
  query
} from 'firebase/firestore';

import { db } from 'configuration/firebase';
import { NewsType } from 'constants/enums';
import type { News } from 'models/news.interface';
import type { CreateNewsFormData } from 'utils/validations/CreateNewsSchema';

export const createNews = async (newsDate: CreateNewsFormData, loggedUserId: string): Promise<News> => {
  try {
    const newsDoc = {
      title: newsDate.title,
      description: newsDate.description,
      createdAt: new Date().getTime(),
      createdBy: loggedUserId,
      type: NewsType.default,
      isHighlighted: false,
    };

    const docRef = await addDoc(collection(db, 'news'), newsDoc);

    return {
      id: docRef.id,
      ...newsDoc,
    } as News;
  } catch (error) {
    console.error('Error creating news:', error);
    throw error;
  }
};

export const getNews = async (): Promise<News[]> => {
  try {
    const newsQuery = query(
      collection(db, 'news'),
      orderBy('createdAt', 'desc')
    );
    const querySnapshot = await getDocs(newsQuery);
    return querySnapshot.docs.map(doc => {
      const { title, description, createdAt, updatedAt, createdBy, isHighlighted } = doc.data();

      return {
        id: doc.id,
        title,
        description,
        createdAt,
        updatedAt,
        createdBy,
        isHighlighted,
      } as News;
    });
  } catch (error) {
    console.error('Error fetching news:', error);
    throw error;
  }
};

export const updateNews = async (
  newsId: string,
  updateData: { title?: string, description?: string, updatedAt?: number, updatedBy?: string, isHighlighted?: boolean }
): Promise<void> => {
  try {
    const newsRef = doc(db, 'news', newsId);
    await updateDoc(newsRef, updateData);
  } catch (error) {
    console.error('Error updating news:', error);
    throw error;
  }
};

export const deleteNews = async (newsId: string): Promise<void> => {
  try {
    await deleteDoc(doc(db, 'news', newsId));
  } catch (error) {
    console.error('Error deleting news:', error);
    throw error;
  }
};
